/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
EXTENDED SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
:host([error]) {
  background-color: #ff74a2;
}

:host([alert]) {
  background-color: #ffc270;
}

:host([success]) {
  background-color: #85d0c1;
}

:host([info]) {
  background-color: #8494ff;
}

:host([dark]) {
  background-color: #0a171f;
  color: #fff;
}

:host([accent]) {
  background-color: #eaf7ff;
}

:host([info]) {
  display: inline-block;
  margin-right: 2em;
}

/* top, bottom and y paddings */
:host([p-0]), :host([pt-0]), :host([py-0]) {
  padding-top: 0;
}

:host([p-0]), :host([pb-0]), :host([py-0]) {
  padding-bottom: 0;
}

:host([p-1]), :host([pt-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pt-1]), ::slotted([py-1]) {
  padding-top: 12px;
}

:host([p-1]), :host([pb-1]), :host([py-1]), ::slotted([p-1]), ::slotted([pb-1]), ::slotted([py-1]) {
  padding-bottom: 12px;
}

:host([p-2]), :host([pt-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pt-2]), ::slotted([py-2]) {
  padding-top: 24px;
}

:host([p-2]), :host([pb-2]), :host([py-2]), ::slotted([p-2]), ::slotted([pb-2]), ::slotted([py-2]) {
  padding-bottom: 24px;
}

:host([p-3]), :host([pt-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pt-3]), ::slotted([py-3]) {
  padding-top: 32px;
}

:host([p-3]), :host([pb-3]), :host([py-3]), ::slotted([p-3]), ::slotted([pb-3]), ::slotted([py-3]) {
  padding-bottom: 32px;
}

:host([p-4]), :host([pt-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pt-4]), ::slotted([py-3]) {
  padding-top: 40px;
}

:host([p-4]), :host([pb-4]), :host([py-4]), ::slotted([p-4]), ::slotted([pb-4]), ::slotted([py-4]) {
  padding-bottom: 40px;
}

:host([p-5]), :host([pt-5]), :host([py-5]) {
  padding-top: 80px;
}

:host([p-5]), :host([pb-5]), :host([py-5]) {
  padding-bottom: 80px;
}

/* left, right and x paddings */
:host([p-0]), :host([pl-0]), :host([px-0]) {
  padding-left: 0;
}

:host([p-0]), :host([pr-0]), :host([px-0]) {
  padding-right: 0;
}

:host([p-1]), :host([pl-1]), :host([px-1]) {
  padding-left: 12px;
}

:host([p-1]), :host([pr-1]), :host([px-1]) {
  padding-right: 12px;
}

:host([p-2]), :host([pl-2]), :host([px-2]) {
  padding-left: 24px;
}

:host([p-2]), :host([pr-2]), :host([px-2]) {
  padding-right: 24px;
}

:host([p-3]), :host([pl-3]), :host([px-3]) {
  padding-left: 32px;
}

:host([p-3]), :host([pr-3]), :host([px-2]) {
  padding-right: 32px;
}

:host([p-4]), :host([pl-4]), :host([px-4]) {
  padding-left: 40px;
}

:host([p-4]), :host([pr-4]), :host([px-4]) {
  padding-right: 40px;
}

:host([p-5]), :host([pl-5]), :host([px-5]) {
  padding-left: 80px;
}

:host([p-5]), :host([pr-5]), :host([px-5]) {
  padding-right: 80px;
}

/* ToDo: Own Mixin for layout */
:host([layout-stretch]), ::slotted([layout-stretch]) {
  display: flex;
  flex-direction: row;
  align-content: space-between;
}

/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
VEAMS SETTINGS
=================================================== */
/* ===================================================
BREAKPOINT SETTINGS
=================================================== */
/* ===================================================
FONTS
=================================================== */
/* ===================================================
FONTSIZES
=================================================== */
/* ===================================================
COLORS
=================================================== */
/* ===================================================
Transitions
=================================================== */
/* ===================================================
Padding / Margin
=================================================== */
/* ===================================================
Misc
=================================================== */
/* ===================================================
Buttons
=================================================== */
/* ---------------------------------------------------
A11y-focus
--------------------------------------------------- */
/* ===================================================
Reset Button
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
Button and Link Styles
=================================================== */
/* ===================================================
Hiding Elements
=================================================== */
/* ---------------------------------------------------
ir
--------------------------------------------------- */
/* ---------------------------------------------------
Hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visually hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Visibility hidden
--------------------------------------------------- */
/* ---------------------------------------------------
Hide text
--------------------------------------------------- */
/* ===================================================
Pseudo Element
=================================================== */
/*
Extend
----------------------- */
/* ===================================================
CENTERING MIXIN
=================================================== */
.c-panel {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(55, 121, 163, 0.24);
  box-sizing: border-box;
  display: block;
  outline: none;
  margin-bottom: 24px;
  padding: 24px;
  position: relative;
}
.c-panel:before, .c-panel:after {
  content: " ";
  display: table;
}
.c-panel:after {
  display: block;
  clear: both;
  height: 1px;
  margin-top: -1px;
  visibility: hidden;
}
.c-panel {
  *zoom: 1;
}
.c-panel :last-child {
  margin-bottom: 0;
}
.c-panel__button {
  position: absolute;
  right: 0;
  top: 20px;
  z-index: 1;
}
.c-panel__icon {
  height: 20px;
  width: 20px;
}
.c-panel[closeable] {
  padding-right: 64px;
}
.c-panel[inline] {
  display: inline-block;
  margin-right: 2em;
}
.c-panel[info] {
  background-color: #8494ff;
}
.c-panel[accent] {
  background-color: #eaf7ff;
}
.c-panel[alert] {
  border: 1px solid #a7003b;
  box-shadow: 0 4px 8px 0 rgba(167, 0, 59, 0.24);
}
.c-panel[fading]::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 96px;
  left: 0;
  z-index: 1;
  background: linear-gradient(180deg, #fff 60%, rgba(255, 255, 255, 0));
  top: 0;
}
.c-panel[primary] {
  background-color: #57beff;
}
.c-panel[flat] {
  box-shadow: none;
}
.c-panel[elevated] {
  box-shadow: 0 12px 32px 0 rgba(55, 121, 163, 0.6);
}
.c-panel[interactive] {
  transition-property: transform, box-shadow;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
}
.c-panel[interactive]:hover, .c-panel[interactive]:active, .c-panel[interactive]:focus, .c-panel[interactive].c-panel--active {
  box-shadow: 0 8px 16px 5px rgba(87, 190, 255, 0.44);
  cursor: pointer;
  transform: scale(1.015);
}
.c-panel[interactive][alert]:hover, .c-panel[interactive][alert]:active, .c-panel[interactive][alert]:focus {
  box-shadow: 0 8px 16px 5px rgba(167, 0, 59, 0.4);
}
.c-panel[attached=bottom] {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  margin-bottom: 0;
}
.c-panel[attached=top] {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.c-panel[centered-content] {
  flex-direction: column;
  justify-content: center;
  display: flex;
}
.c-panel[centered-content] ::slotted(div) {
  margin: 0 auto;
}
.c-panel[layout-stretch] {
  align-content: space-between;
  display: flex;
  flex-direction: row;
}
.c-panel[layout-stretch] ::slotted(div) {
  margin: 0 auto;
}